export const createParsedData = ({
  rolesCount,
  qualificationsCount,
}: {
  rolesCount: number;
  qualificationsCount: number;
}) => [
  {
    document: 'resume',
    section: 'career-history',
    info: rolesCount !== 0 ? 'new-info' : 'no-new-info',
    count: rolesCount,
  },
  {
    document: 'resume',
    section: 'education',
    info: qualificationsCount !== 0 ? 'new-info' : 'no-new-info',
    count: qualificationsCount,
  },
];
